import {
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Tooltip,
} from "@material-ui/core";
import React, { useEffect } from "react";
import { useState } from "react";
import { FiltroRepPlano2DTO } from "../../models/controlls.model";
import MoreVertIcon from "@material-ui/icons/MoreVert";

export default function InputC(props: inputCProps) {
  const [inputValue, setInputValue] = useState("");
  const campo: string = props.id.split("-")[0];
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openFilter, setOpenFilter] = useState(false);
  const [operadorSelect, setOperadorSelect] = useState("igual a");
  const [blured, setBlured] = useState(false);

  useEffect(() => {
  
    let filtro = {
      campo: campo,
      valor: [inputValue],
      operador: operadorSelect,
      nombreColumna: props.nombreColumna,
      filtro: props.filtro,
    };
    if (props.filtros[campo] !== undefined)
      props.filtros[campo]["nombreColumna"] = props.nombreColumna;
    props.guardaSeleccion(campo, filtro);
  }, []);

  const handleChange = (value: string): void => {
    setInputValue(value);
    props.filtros[campo].valor = [value];
    props.filtros[campo].operador = operadorSelect;
    props.filtros[campo]["nombreColumna"] = props.nombreColumna;
  };

  const handleClickIco = (event: React.MouseEvent<HTMLButtonElement>) => {
    let element = document.getElementById(
      event.currentTarget.id
    ) as HTMLElement;
    setAnchorEl(element);
    setOpenFilter(true);
  };

  const handleClose =
    (operador: string) => (event: React.MouseEvent<HTMLElement>) => {
      setOpenFilter(false);

      if (operador !== "" && operador !== "eliminar")
        setOperadorSelect(operador);

      if (operador === "eliminar") props.eliminaInput(props.id, props.filtro);

      setAnchorEl(null);
    };

  const validation = (): boolean => {
    return !(!props.error || !blured || inputValue.length > 0);
  };

  return (
    <>
      <TextField
        type={props.type}
        label={props.label}
        value={inputValue}
        error={validation()}
        helperText={validation() ? props.labelError : ''}
        onChange={(e) => handleChange(e.target.value)}
        onBlur={() => setBlured(true)}
        InputProps={{
          endAdornment: (
            <React.Fragment>
            {!props.onlySentence ? (
              <>
                <Tooltip title={"Eliminar"}>
                  <IconButton
                    id={`ico-${campo}`}
                    aria-label="more"
                    aria-controls="long-menu"
                    aria-haspopup="true"
                    onClick={handleClickIco}
                  >
                    <MoreVertIcon />
                  </IconButton>
                </Tooltip>
                <Menu
                  id={`menu-${campo}`}
                  anchorEl={anchorEl}
                  keepMounted
                  open={openFilter}
                  onClose={handleClose("")}
                >
                  <MenuItem
                    id={`subME-${campo}`}
                    onClick={handleClose("eliminar")}
                  >
                    eliminar
                  </MenuItem>
                </Menu>
              </>
                ) : null}
            </React.Fragment>
          ),
        }}
        style={{
          width: "98%",
        }}
      />
    </>
  );
}

interface inputCProps {
  id: string;
  filtro: boolean;
  filtros: any;
  type: string;
  label: string;
  onlySentence: boolean;
  error: boolean;
  labelError: string;
  nombreColumna: string;
  eliminaInput(idCampo: string, filtroInput: boolean): void;
  guardaSeleccion(campo: string, filtro: FiltroRepPlano2DTO): void;
}

InputC.defaultProps = {
  type: "text",
  error: false,
  onlySentence: false,
  labelError: "Campo requerido.",
};
